import {RoleEnum} from "@shared/Permissions/RoleEnum.js";

export function getRequiredRole(route){
	if(route.matched.some(record => record.meta.coachAuth)) return RoleEnum.COACH
	if(route.matched.some(record => record.meta.clientAuth)) return RoleEnum.CLIENT
	return null
}

export function isWhitelisted(route){
	return route.matched.some(record => record.meta.isWhitelisted || false)
}

export function isPrintView(route){
	return route.matched.some(record => record.meta.isPrintView || false)
}

export function requiresAccount(route){
	return !!getRequiredRole(route) || !isWhitelisted(route)
}
